import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Check, Close, ExpandMore } from '@mui/icons-material';
import { useFormikContext } from 'formik';
import Form from './form';
import {
  DocumentVM,
  CommonInterfaceSubscription,
} from 'subscription/view-models/common-interface-subscription';

interface AccordionDocumentProps {
  isAire?: boolean;
}

const AccordionDocumentComponent = ({
  isAire = false,
}: AccordionDocumentProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<CommonInterfaceSubscription>();

  const onChange = useEventCallback(
    (key: keyof DocumentVM, value: DocumentVM[keyof DocumentVM]) => {
      formContext.setFieldValue('document', {
        ...(formContext.values.document || {}),
        [key]: value,
      });
    }
  );

  const onChanges = useEventCallback((values: DocumentVM) => {
    formContext.setFieldValue('document', {
      ...(formContext.values.document || {}),
      ...(values || {}),
    });
  });

  return isAire ? (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="accordion-attachments-content"
        id="accordion-attachments-header"
        expandIcon={<ExpandMore />}
      >
        {formContext.errors.document ? <Close color="error" /> : <Check color="success" />}
        <Typography>Documenti</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Form onChange={onChange} onChanges={onChanges} values={formContext.values.document} />
      </AccordionDetails>
    </Accordion>
  ) : (
    <></>
  );
};

AccordionDocumentComponent.displayName = 'accordion Document';

const AccordionDocument = memo(AccordionDocumentComponent);

export default AccordionDocument;
